
<nav class="navbar navbar-expand-lg fixed-top  " [class.b]="show">
    <div class="container">
    <a class="navbar-brand" href="#"><img src="../../../assets/Path 12528.png" alt=""> </a>
    <button  (click)="Tshow()" style="    padding: 13px 20px 9px 17px;" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>      <span class="navbar-toggler-icon"></span>
      <span class="navbar-toggler-icon"></span>

    </button>
  
    <div style="margin-right: 154px;" class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto ">
        <li class="nav-item active">
          <a class="nav-link" routerLinkActive="active" routerLink="/Solutions">Solutions </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/Academy">Academy  </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/about"> About </a>
          </li>
          <li  class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/blog"> blog </a>
          </li>
       
         
          </ul>
        
        
          
        
    </div>
    </div>
  </nav>